@if (items?.length === 0) {
  <div>
    <glxy-empty-state [size]="'small'">
      <glxy-empty-state-hero>
        <mat-icon>search_off</mat-icon>
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{ 'HTML_EDITOR.DYNAMIC_CONTENT.NO_DATA_FOUND' | translate }}
      </glxy-empty-state-title>
      <p>
        {{ 'HTML_EDITOR.DYNAMIC_CONTENT.NO_DATA_FOUND_DESCRIPTION' | translate }}
      </p>
    </glxy-empty-state>
  </div>
}
@if (items?.length > 0) {
  <div>
    <glxy-form-field size="small">
      <glxy-label>{{ parentTextKey | translate }}</glxy-label>
      <mat-select [formControl]="formControl">
        @for (item of items || []; track item) {
          <mat-option [value]="item">
            {{ item.textKey | translate }}
          </mat-option>
        }
      </mat-select>
    </glxy-form-field>
    @if (formControl.value?.subItems$ | async; as subItems) {
      @if ($any(subItems || []).length > 0) {
        <app-variable-menu-item-selector
          [items]="subItems"
          [parentTextKey]="formControl.value.textKey"
          (variableMenuItemSelected)="childComponentVariableMenuItemSelected($event)"
        ></app-variable-menu-item-selector>
      }
    }
  </div>
}
